import { render, staticRenderFns } from "./FolderSettings.vue?vue&type=template&id=70f8b0d4&"
import script from "./FolderSettings.vue?vue&type=script&lang=ts&"
export * from "./FolderSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports